import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock, Send, MessageCircle,ChevronRight  } from 'lucide-react';

const contactPoints = [
  { icon: Mail, label: 'Email', value: 'support@trivenipay.com', href: 'mailto:support@trivenipay.com' },
  { icon: Phone, label: 'Phone', value: '+91 98765 43210', href: 'tel:+919876543210' },
  { icon: MapPin, label: 'Office', value: 'Financial District, Bhopal, Madhya Pradesh, India' },
  { icon: Clock, label: 'Support Hours', value: 'Mon – Sat, 9:00 AM – 7:00 PM IST' },
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill in your name, email, and message.');
      return;
    }
    setSending(true);
    // No dedicated /contact API on the backend yet — this simulates the
    // send so the page is fully usable today. Wire this up to a real
    // endpoint (e.g. POST /api/contact) once one exists.
    setTimeout(() => {
      setSending(false);
      toast.success('Message sent! Our team will get back to you soon.');
      setForm({ name: '', email: '', subject: '', message: '' });
    }, 900);
  };

  return (
    <>
      <Navbar />

      {/* PAGE HEADER */}
      <section className="page-banner">
        <div className="page-banner-bg" style={{ backgroundImage: 'url(/mlm2.png)' }} />
        <div className="page-banner-overlay" />
        <div className="container page-banner-content">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="breadcrumb-item">Home</Link>
            <ChevronRight size={14} className="breadcrumb-sep" />
            <span className="breadcrumb-item breadcrumb-current">About</span>
          </nav>
          <h1 className="page-banner-title">
            Get In <span style={{ color: 'var(--primary-light, #6fa0ff)' }}>Touch</span>
          </h1>
          <p className="page-banner-sub">
Questions about your package, a withdrawal, or how Triveni Pay works? Send us a message our team replies within one business day.          </p>
        </div>
      </section>

      {/* CONTACT GRID */}
      <section className="section section-alt">
        <div className="container">
          <div className="grid-2" style={{ gap: 40, alignItems: 'flex-start' }}>
            {/* Form */}
            <div className="card">
              <h3 className="card-title" style={{ marginBottom: 20 }}>Send a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="grid-2" style={{ gap: 20 }}>
                  <div className="form-group">
                    <label>Your Name</label>
                    <input type="text" name="name" className="form-control" placeholder="Ramesh Kumar" value={form.name} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Email Address</label>
                    <input type="email" name="email" className="form-control" placeholder="you@example.com" value={form.email} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <input type="text" name="subject" className="form-control" placeholder="Withdrawal query, package question, etc." value={form.subject} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Message</label>
                  <textarea name="message" className="form-control" rows={5} placeholder="Tell us how we can help..." value={form.message} onChange={handleChange} style={{ resize: 'vertical' }} />
                </div>
                <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={sending}>
                  {sending ? 'Sending...' : <>Send Message <Send size={16} /></>}
                </button>
              </form>
            </div>

            {/* Contact info */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {contactPoints.map(point => (
                <div key={point.label} className="income-type-card">
                  <div className="income-type-icon"><point.icon size={22} /></div>
                  <div>
                    <div className="income-type-name">{point.label}</div>
                    {point.href ? (
                      <a href={point.href} className="income-type-desc" style={{ color: 'var(--text-light)' }}>{point.value}</a>
                    ) : (
                      <div className="income-type-desc" style={{ color: 'var(--text-light)' }}>{point.value}</div>
                    )}
                  </div>
                </div>
              ))}

              <div className="card" style={{ borderColor: 'rgba(var(--primary-rgb),0.5)', background: 'linear-gradient(135deg, rgba(var(--primary-rgb),0.08), rgba(var(--secondary-rgb),0.08))' }}>
                <p style={{ color: 'var(--text-light)', fontSize: '0.92rem', lineHeight: 1.7 }}>
                  For account-specific issues (KYC, withdrawals, package activation), please log in and check your <strong style={{ color: 'var(--primary)' }}>Dashboard</strong> first many queries are answered instantly there.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}